/**
 * @desc: -  报表基类
 * @author: danny
 */

import {DateGroup,RangeGroup,SearchGroup,Pagintaion} from "./ReportComponent.jsx";
import React from 'react';
import * as UNIT from '../../../helpers/unit.js'

export default class ReportBase extends React.Component{
	
	constructor(props){
		super(props)
		UNIT.importDatePrototype();
		// 默认查询今天
		var date = new Date()
		date.setDate(date.getDate() + 1)
		var endDate = new Date(date).pattern('YYYY-MM-DD 02:00:00');
		date.setDate(date.getDate() - 10)
		var startDate = date.pattern('YYYY-MM-DD 02:00:00')
		
		this.state = {
			//查询的参数
			searchValue:'',
			endDate:endDate,
			startDate:startDate,
			rangeOptionValue:0,
			rangeOptionValue1:0,
			orderBy:'',
			sort:'desc',
			pageNum:1,
			//页数，查询范围范围选择
			page_size:15,
			total_page:1,
			rangeValue:'',
			rangeValue1:'',
			rangeIndex:0,
			rangeIndex1:0,
			breadItem:{userid:0,username:''},
			popUpCurrent:'none',
		}
		this.searchChange = this.searchChange.bind(this);
		this.rangeMenuClick = this.rangeMenuClick.bind(this);
		this.refer = this.refer.bind(this);
		this.onStartChange = this.onStartChange.bind(this);
		this.onEndChange = this.onEndChange.bind(this);
		this.tableTitleClick = this.tableTitleClick.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.breadChange = this.breadChange.bind(this);
		this.breadRefer = this.breadRefer.bind(this);
		this.popUpToggle = this.popUpToggle.bind(this);
	}
	

	
	//加载页面的同时，下载数据，更快的显示出界面
	componentWillMount(){
		this.refer()
	}
	
	componentWillUnmount() {
		// 销毁
		//this.props.$$REPORT.distroyCurrentView();
	}
	//关闭弹出框
	popUpToggle(current){
		this.setState({
			popUpCurrent:current
		})
		this.refer()
	}
	//搜素变化，没有实时搜索
	searchChange(value){
		this.setState({
			searchValue:value
		})
	}
	
	breadChange(item){
		this.state.breadItem.userid = item.userid;
		this.state.searchValue = ''
		this.setState({
		})
		this.breadRefer();
	}
	
	//当开始日期变化时，实时搜索
	onStartChange(value){
		this.state.startDate = value._d.pattern("YYYY-MM-DD 02:00:00");
		this.setState({
			startDate:value._d.pattern("YYYY-MM-DD 02:00:00"),
		})
		this.refer();
	}
	//当结束日期变化时，实时搜索
	onEndChange(value) {
		this.state.endDate = value._d.pattern("YYYY-MM-DD 02:00:00");
		this.setState({
			endDate: value._d.pattern("YYYY-MM-DD 02:00:00"),
		});
		this.refer();
	}
	
	//当查询范围变化时，实时搜索
	rangeMenuClick(key,value,rangeOptionValue){
		this.state.rangeIndex=key;
		this.state.rangeValue=value;
		this.state.rangeOptionValue=rangeOptionValue;
		this.setState({
			rangeIndex:key,
			rangeValue:value,
			rangeOptionValue:rangeOptionValue
		});
		this.refer()
	}
	//点击表格标题，更换查询字段以及 排序方法
	tableTitleClick(orderBy){
		this.setState({
			sort : this.state.sort == 'desc'? 'asc':'desc',
			orderBy : orderBy
		})
		this.refer()
	}
	//查询其他页数
	onPageChange(page,pagesize){
		this.state.pageNum = page;
		this.state.page_size = pagesize
		this.setState({
			pageNum:page,
			page_size:pagesize
		})
		
		this.refer()
	
	}
	//底部分页
	renderPage(info){
		const {moreExpansoin,warningList,orderBy,sort,page_size,total_page,pageNum} = this.state;
		const __report = this.props.__REPORT.toJS();
		
		if(info == '') info = '共 '+total_page+" 页,当前第 "+pageNum+" 页";
		
		if(__report.current_view && __report.current_view.page){
			
			return <Pagintaion current={pageNum}
			                   onChange={(page,pagesize)=>{this.onPageChange(page,pagesize)}}
			                   page_size={__report.current_view.page.page_size}
			                   total_page={__report.current_view.page.total_page}
			                   info={info}/>
		}
		return <Pagintaion onChange={(page,pagesize)=>{this.onPageChange(page,pagesize)}} page_size={10} total_page={1} info={info}/>
		
	}
	//查询的方法，子类覆盖
	refer(){
	}
	
	breadRefer(){
	
	}
	
	//子类覆盖
	render(){
		return <div>
		
		</div>
	}
}